import React from 'react';

const BackgroundSVG: React.FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="452" height="397" viewBox="0 0 452 397" fill="none">
			<path
				d="M442.418 68.7888C480.826 140.96 387.688 282.428 336.318 344.14C303.072 384.079 268.179 416.07 168.148 381.269C-48.9587
				305.736 -1.27606 145.607 22.6218 73.0445C46.5197 0.481748 106.617 -11.0724 177.881 10.5212C234.892 27.796 279.267 28.0787
				294.328 26.0607C327.688 10.232 404.01 -3.38273 442.418 68.7888Z"
				fill="#FFDD60"
			/>
		</svg>
	);
};

export default BackgroundSVG;
